var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center flex gap-3"},_vm._l((_vm.social),function(item){return _c('Link',{key:item.page,attrs:{"url":item.url}},[_c('span',{staticClass:"text-2xl",class:("iconify " + (item.page))})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }